import { FC } from 'react'
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'
import { ColorsEnum } from '../../../constants/colors'
import { FontsEnum } from '../../../constants/fonts'

interface ColumnStateProps {
    title: string
    style?: StyleProp<ViewStyle>
}

const ColumnDataState: FC<ColumnStateProps> = ({ title, style }) => {
    return (
        <View style={[styles.container, style]}>
            <Text style={styles.text}>{title}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        borderColor: ColorsEnum.GRAY_DARK,
        borderRadius: 4,
        borderWidth: 1,
        height: 108,
        maxHeight: 114,
    },
    text: {
        color: ColorsEnum.GRAY_DARK,
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 17,
        textAlign: 'center',
    },
})

export default ColumnDataState
